import { render, staticRenderFns } from "./cxMgmt.vue?vue&type=template&id=1036649f&scoped=true&"
import script from "./cxMgmt.vue?vue&type=script&lang=js&"
export * from "./cxMgmt.vue?vue&type=script&lang=js&"
import style0 from "./cxMgmt.vue?vue&type=style&index=0&id=1036649f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1036649f",
  null
  
)

export default component.exports